<template>
  <div>
    <template v-for="nav in navList">
      <el-submenu
        v-if="nav.subNavList.length >= 1 && !nav.isGroupTitle"
        :key="nav.path"
        :index="nav.path"
      >
        <template slot="title">
          <span slot="title">{{ nav.title }}</span>
        </template>
        <SubMenu
          :nav-list="nav.subNavList"
        />
      </el-submenu>
      <el-menu-item-group
        v-else-if="nav.isGroupTitle"
        :key="nav.path"
      >
        <template slot="title">
          {{ nav.title }}
        </template>
      </el-menu-item-group>
      <el-menu-item
        v-else-if="!isExternalLink(nav.path)"
        :key="nav.path"
        :index="nav.path"
      >
        {{ nav.title }}
      </el-menu-item>
      <a
        v-else
        :key="nav.path"
        style="color: init"
        target="_blank"
        :href="nav.path"
        class="external-link-item el-menu-item"
      >
        {{ nav.title }}
      </a>
    </template>
  </div>
</template>
<style>
</style>
<script>
export default {
  name: 'SubMenu',
  props: {
    navList: {
      default() {
        return [];
      },
      type: Array
    }
  },
  methods: {
    isExternalLink(link) {
      if (typeof link !== 'string') {
        return false;
      }
      if (link.indexOf('https') === 0 || link.indexOf('http') === 0) {
        return true;
      }
      return false;
    },
  }
};
</script>
<style lang="scss">
  .external-link-item {
    display: block;
    font-size: 14px;
    color: #303133;
    /* padding: 0 30px; */
    cursor: pointer;
    transition: border-color .3s,background-color .3s,color .3s;
    box-sizing: border-box;
    height: 44px;
    line-height: 44px;
    position: relative;
    -webkit-box-sizing: border-box;
    white-space: nowrap;
    list-style: none;
    &:hover {
      outline: 0;
      background-color: #ecf5ff;
    }
  }
</style>
